/**
 * Internal dependencies
 */
import type { Session } from '../../types';

export function getCollapsedAlternative( session: Session ): number {
	return isAlternativeDistributionEnabled( session )
		? session.alternative
		: session.alternative % getNumOfAlternatives( session );
}

// =======
// HELPERS
// =======

function isAlternativeDistributionEnabled( session: Session ) {
	return session.experiments.some( ( e ) => e.alternativeCuts );
}

function getNumOfAlternatives( session: Session ): number {
	const altCounts = session.experiments
		.filter( ( e ) => e.active )
		.map( ( e ) => e.alternatives.length )
		.filter( ( as ) => !! as );

	if ( ! altCounts.length ) {
		return 1;
	}

	return altCounts.reduce( lcm, 1 );
}

function lcm( n: number, m: number ): number {
	return m * ( n / gcd( n, m ) );
}

function gcd( n: number, m: number ): number {
	return m === 0 ? Math.abs( n ) : gcd( m, n % m );
}
